(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShopSelectDialogController', ShopSelectDialogController);

    ShopSelectDialogController.$inject = ['paginationConstants', 'Outlets', '$uibModalInstance'];

    function ShopSelectDialogController (paginationConstants, Outlets, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 贩卖店列表
        vm.shopList = [];

        // 查询条件
        vm.searchData = {id: "", name: "", person: ""};
        vm.defaultSearchData = {id: "", name: "", person: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();

        function loadData() {
            Outlets.query({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name,
                person: vm.searchData.person}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.shopList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();
